/**
 * PdfUploader service upload is used to upload all files (PDF, Word, PowerPoint, ...) to upload servers.
 * It triggers event directly on global model.
 */
fx.service( class PdfUploader extends fx.Service {

    constructor(model)
    {
        super();

        this.model = model.creationModel;

        this._onProgressHandler = this._onProgress.bind(this);

        this._forceAborting = false;

        this._docid = null;
    }

    
    get uploading()
    {
        return this._currentFile != null;
    }

    get converting()
    {
        return this._currentFile && this._currentFile.progress;
    }

    get total()
    {
        return this._currentFile ? (this._currentFile.upload && this._currentFile.upload.size ? this._currentFile.upload.size : 0) : 0;
    }

    get position()
    {
        return this._currentFile ? (this._currentFile.upload && this._currentFile.upload.loaded ? this._currentFile.upload.loaded : 0) : 0;
    }

    

    upload(file)
    {
        if (this._currentFile)
        {
            this.model.event("file-already-processing");
            return;
        }

        this._forceAborting = false;
        this._docid = null;

        if (file instanceof Array)
            file = file[0];

        this._currentFile = { file : file } ;
        
        this._uploadFile();
    }

    
    abortUploading()
    {
        this._forceAborting = true;
        this._currentFile = null;
        this.abort( this._request );
    }

    askNotification()
    {
        this.post('https://jobs.flexilivre.com/upload-notify', {docid : this._docid, notify : 1});
    }


    _uploadFile()
    {
        this.model.event("file-uploading");

        this._currentFile.upload = {uploaded : false, uploading:true, tries : 0, loaded : 0, size : this._currentFile.file.size};

        var formData = new FormData();
        formData.append('type', "filejs");
        formData.append('accountid', this.model.account.id);
        formData.append('bookid', this.model.creation.id);
        formData.append('file', this._currentFile.file);
       
        this._request = this.post('https://jobs.flexilivre.com/editor-upload', formData, this._uploadResult, {processData: false,  contentType: false, timeout : 0, progressCallBack : this._onProgressHandler, maxTries : 1 });
    }
    
    _onProgress(loaded, total)
    {
        // console.log(loaded, total);
        this._currentFile.upload.loaded = loaded;

        //this.model.event("upload-file-progress");
        this.model.event("file-upload-progress");
    }

    _uploadResult(result)
    {
        if (result.success && result.success == true)
        {
            this._currentFile.upload.loaded = this._currentFile.upload.size;
            this._currentFile.upload.uploading = false;
            this._currentFile.upload.uploaded = true;

            this._docid = result.docid;
            
            this.model.event("file-uploaded");

            this._conversionProgress();
        }
        else
        {
            this._currentFile = null;
            if (result.details != "abort")
                this.model.event("file-upload-failed");
        }
    }

    _conversionProgress()
    {
        let url = "https://jobs.flexilivre.com/convert-status";

        this.post(
            url,
            {
                docid: this._docid, 
                connectionid : this.model.connectionid
            },
            this._onConversion);

    }

    _onConversion(data)
    {
        if (data.error)
        {
            this.model.event("file-conversion-error");
            return;
        }

        this._currentFile.progress = data;

        if (this._currentFile.progress.status != 1)
            this.delay(this._conversionProgress, 5000);
        else
            this._getPhotos();
    }

    _getPhotos()
    {
        this._currentFile = null;

        let url = "https://www.flexilivre.com/api/photos";

        this.get(
            url,
            {
                action: "filephotos",
                docid: this._docid,
                connectionid : this.model.connectionid
            },
            this._addPhotos); 
    }

    _addPhotos(data)
    {
        // depending we are using config or editor
        let creation = this.model.creationModel || this.model.creation;

        if (data.error)
            this.model.event("get-imported-file-error", data);
        else if (data.length > 0)
        {
            for (let i = 0; i < data.length; i++)
                creation.photos.addItem(data[i]);
        }
        
        this.model.event("pdf-upload-notification");
    }

    

});

